import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES } from "../../helpers/constants";
import Sidebar from "./Sidebar";

const PostPurchaseScreen: React.FC = () => (
    <div className="pg-login-screen">
        <div className="pg-login-screen__content">
            <Sidebar />
            <div className="pg-login-screen__main">
                <div className="pg-login-screen__form-wrapper">
                    <Box textAlign="center">
                        <Typography variant="h5" fontWeight={600} mb={3}>
                            Your account is being created...
                        </Typography>
                        <Typography variant="body1" mb={2}>
                            Please wait, your account is currently being set up.
                            Do not refresh the page. This may take a few moments.
                        </Typography>
                        <CircularProgress sx={{ color: "#FD3300", mt: 2 }} />
                        <Typography variant="body2" mt={2}>
                            Need Help With Login?{" "}
                            <Link to={ROUTES.CONTACT_US} className="pg-login-screen__link">
                                Contact Us
                            </Link>
                        </Typography>
                    </Box>
                </div>
            </div>
        </div>
    </div>
);

export default PostPurchaseScreen;
